import { CreateOrUpdateRelativesInfoValidation } from "@/validations/survey.validations";
import { useFormik } from "formik";
import { Form, Input, Row, Col, Button, Divider, Select, Alert, message } from "antd";
import { AppButton, Flex, FormLabel } from "@/components/common";
import { useTranslation } from "react-i18next";
import { BsPlusCircle, BsTrash3Fill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Routes } from "@/routes";
const DEFAULT_FORM_ITEM = {
  relation: '',
  firstName: '',
  lastName: '',
  studyLevelId: undefined,
  age: undefined,
  job: '',
  contactInfo: '',
  address: ''
}

export interface RelativesInfoFormProps {
  relativesinfo: RelativesInfoEntity[];
  studyLevels: StudyLevelEntity[];
  submitRelativesInfo: (data: RelativesInfoEntity[]) => Promise<any>;
  relationsList: string[];
}

export function RelativesInfoForm({ relativesinfo, studyLevels, submitRelativesInfo, relationsList }: RelativesInfoFormProps) {

  const formikinit = relativesinfo.length > 0 ? relativesinfo : [{ ...DEFAULT_FORM_ITEM }];

  const [t] = useTranslation(['common', 'survey']);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: formikinit,
    validateOnMount: true,
    validationSchema: CreateOrUpdateRelativesInfoValidation(t),
    onSubmit: async (data) => {
      try {
        await submitRelativesInfo(data);
        message.success('اطلاعات با موفقیت ذخیره شد');
        navigate(Routes.Surveys);
      }
      catch (e) {
        console.log(e);
      }
    },
  })

  const addNewRelative = () => {
    formik.setValues([...formik.values, { ...DEFAULT_FORM_ITEM }])
  }

  const removeRelative = (index: number) => {
    formik.setValues(formik.values.filter((_, i) => i !== index));
  }


  return (
    <Flex className="max-w-5xl" direction="column" justify="center" align="center">
      <Flex direction="column" className=" mx-auto bg-app-gray-formBg rounded-md p-5">
        <Form onFinish={formik.handleSubmit}>
          {formik.values.map((_item, index) => (
            <Row gutter={[24, 24]} key={index} >
              <Col span={12} md={8}>
                <FormLabel>رابطه</FormLabel>
                <Select
                  className="w-full block"
                  value={formik.values[index].relation}
                  onChange={(value) => formik.setFieldValue(`[${index}].relation`, value)}
                  options={relationsList.map(item => ({ label: item, value: item }))}
                />
              </Col>
              <Col span={12} md={8}>
                <FormLabel>نام خویشاوند</FormLabel>
                <Input
                  name={`[${index}].firstName`}
                  spellCheck="false"
                  onPressEnter={formik.submitForm}
                  onChange={formik.handleChange}
                  value={formik.values[index].firstName}
                />
              </Col>
              <Col span={12} md={8}>
                <FormLabel>نام خانوادگی خویشاوند</FormLabel>
                <Input
                  name={`[${index}].lastName`}
                  spellCheck="false"
                  onPressEnter={formik.submitForm}
                  onChange={formik.handleChange}
                  value={formik.values[index].lastName}
                />
              </Col>
              <Col span={12} md={8}>
                <FormLabel>میزان تحصیلات</FormLabel>
                <Select
                  className="w-full block"
                  value={formik.values[index].studyLevelId}
                  onChange={(value) => formik.setFieldValue(`[${index}].studyLevelId`, value)}
                  options={studyLevels?.map(item => ({ label: item.name, value: item.id }))}
                />
              </Col>
              <Col span={12} md={8}>
                <FormLabel>شغل</FormLabel>
                <Input
                  name={`[${index}].job`}
                  spellCheck="false"
                  onPressEnter={formik.submitForm}
                  onChange={formik.handleChange}
                  value={formik.values[index].job}
                />
              </Col>
              <Col span={12} md={8}>
                <FormLabel>سن</FormLabel>
                <Input
                  name={`[${index}].age`}
                  spellCheck="false"
                  onPressEnter={formik.submitForm}
                  onChange={formik.handleChange}
                  value={formik.values[index].age}
                />
              </Col>
              <Col span={12} md={8}>
                <FormLabel>شماره تماس</FormLabel>
                <Input
                  name={`[${index}].contactInfo`}
                  spellCheck="false"
                  onPressEnter={formik.submitForm}
                  onChange={formik.handleChange}
                  value={formik.values[index].contactInfo}
                />
              </Col>
              <Col span={24}>
                <FormLabel>آدرس محل سکونت</FormLabel>
                <Input.TextArea rows={8}
                  name={`[${index}].address`}
                  spellCheck="false"
                  onPressEnter={formik.submitForm}
                  onChange={formik.handleChange}
                  value={formik.values[index].address}
                />
              </Col>
              {formik.values.length !== 1 &&
                <Button danger onClick={() => removeRelative(index)} className="ms-auto ml-3">
                  <BsTrash3Fill />
                  حذف رکورد
                </Button>}
              {index !== formik.values.length - 1 && <Divider className="!my-5" />}

            </Row>
          ))}

        </Form>
        <Button
          variant="link"
          type="link"
          className="w-36 !text-app-blue"
          onClick={addNewRelative}
        >
          <BsPlusCircle
            size="1rem"
            style={{ minWidth: '1rem' }} />

          {t('survey:labels.add-other-relatives')}
        </Button>
      </Flex>
      <Alert type="warning" className="flex ms-auto max-h-16 mt-2  text-2xs" message={"به منظور ذخیره اطلاعات لازم است حداقل اطلاعات پدر و مادر گرامی‌تان را اضافه فرمایید."} />
      <AppButton
        // loading={uploading}
        // disabled={uploading}
        // onClick={handleUpload}
        className="w-36 self-end"
        type="primary"
        onClick={formik.submitForm}
        appVariant="submit">
        {t('common:labels.confirm-submit')}
      </AppButton>
    </Flex>

  );
}

export default RelativesInfoForm;
